import { MessageCircleCheckIcon, PencilIcon, Trash2Icon } from '@air/design-icons';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

type GetDiscussionCommentMenuOptionsParams = {
  onDelete?: () => void;
  onEdit?: () => void;
  onResolve?: () => void;
};

export const getDiscussionCommentMenuOptions = ({
  onDelete,
  onEdit,
  onResolve,
}: GetDiscussionCommentMenuOptionsParams): DropdownMenuOption[] => {
  const options: DropdownMenuOption[] = [];

  if (onResolve) {
    options.push({
      id: 'resolve',
      label: 'Resolve',
      onSelect: onResolve,
      prefix: <MessageCircleCheckIcon size="sm" />,
      type: 'item',
    });
  }

  if (onEdit) {
    options.push({
      id: 'edit',
      label: 'Edit',
      onSelect: onEdit,
      prefix: <PencilIcon size="sm" />,
      type: 'item',
    });
  }

  if (onDelete) {
    options.push({
      id: 'delete',
      label: 'Delete comment',
      onSelect: onDelete,
      prefix: <Trash2Icon size="sm" />,
      type: 'item',
    });
  }

  return options;
};
